import { HostAppEventHandlerFactory } from "../../factory/HostAppEventHandlerFactory";

/*All Host App event should be updated here.
  1-100 are reserved for One Note client, Other Host App Event should
  from 101 */
export enum HostAppEvent {
    ONENOTE_PAGE_CHANGED,
    AUDIO_PLAYER_SEEK_TO,
    AUDIO_PLAYER_STOP,
    ONENOTE_PAGE_DELETED,
    ONENOTE_PAGE_MOVED,
    ONENOTE_NOTEBOOK_CLOSED
}

export namespace HostAppEvent {
    export function GetString(event: HostAppEvent): string {
        return HostAppEvent[event];
    }

    export function FetchEvent(str: string): HostAppEvent {
        return (HostAppEvent as any)[str];
    }
}

/**
* OnHostAppEventReceived is received from OneNote client side to Transcription Pane.
* @method OnHostAppEventReceived
* @param {eventId} number representing event, check @enum {HostAppEvent} for more details.
* @param {eventInfo} Json {"key1": value, "key2": value} carrying details related to event.
* @return {} void
*/
export function OnHostAppEventReceived(eventId: number, eventInfo: any = {}): void {
    if (typeof eventInfo == "string") {
        let eventInfoJson;
        try {
            eventInfoJson = JSON.parse(eventInfo);
        } catch (e) {
            throw new Error("Incorrect Json format for eventInfo.");
        }
        HostAppEventHandlerFactory.GetInstance().HandleEvent(HostAppEvent.FetchEvent(HostAppEvent[eventId]), eventInfoJson);
    } else {
        HostAppEventHandlerFactory.GetInstance().HandleEvent(HostAppEvent.FetchEvent(HostAppEvent[eventId]), eventInfo);
    }
}

/*API to be called from host app client side to inject host app Event
  to Transcription Pane*/
(<any>window).InjectEventToTranscriptionPane = OnHostAppEventReceived;